import paycoUtils from '@/assets/js/utils'

interface IMembership {
  accountTypeCode: string;
  cardNo: string;
  restPoint: number;
  usePoint: number;
  selected: boolean;
  useAbleMinOwnPoint?: number;
  useMaxSavePoint?: number;
  useMinSavePoint?: number;
  useSavePointUnit?: number;
}

class Membership {
  constructor(args: IMembership) {
    return Object.assign(this, args);
  }

  get displayRestPoint(): string {
    return paycoUtils.numWithCommas(this.restPoint) + '원';
  }

}

interface Membership extends IMembership {
}

export default Membership;